"use strict";
exports.__esModule = true;
var HexHelpler = (function () {
    function HexHelpler() {
    }
    HexHelpler.removeLeading0xPrefix = function (key) {
        return key.startsWith("0x") ? key.replace("0x", "") : key;
    };
    HexHelpler.add0xPrefix = function (key) {
        return key.startsWith("0x") ? key : "0x" + key;
    };
    return HexHelpler;
}());
exports["default"] = HexHelpler;
//# sourceMappingURL=HexHelper.js.map